import type { Feature, Position, LineString } from "geojson";
import union from "@turf/union";
import type { SimplePoint } from "@ptx-autonomous/libs/api-models";
import { advancedBuffer } from "../utils/advanced-buffer";

export function createEstimatedCoverage(
	plannedPath: SimplePoint[],
	implementWidth: number,
) {
	// Split path into individual swaths at each "TURN" label
	const swaths: Position[][] = [];
	let currentSwath: Position[] = [];
	for (const point of plannedPath) {
		if (point.Label === "TURN") {
			if (currentSwath.length) {
				currentSwath.push([point.Long, point.Lat]);
				swaths.push(currentSwath);
				currentSwath = [];
			}
			continue;
		}
		currentSwath.push([point.Long, point.Lat]);
	}
	if (currentSwath.length) swaths.push(currentSwath);

	// Filter out swaths that have only one point
	const swathPaths = swaths.filter(swath => swath.length > 1);

	if (swathPaths.length === 0) {
		return undefined;
	}

	// Create a buffered polygon for each swath
	const estimatedCoverageFeatures = swathPaths.map(swathCoordinates => {
		const swathFeature: Feature<LineString> = {
			type: "Feature",
			properties: {},
			geometry: {
				type: "LineString",
				coordinates: swathCoordinates,
			},
		};

		return advancedBuffer(swathFeature, {
			distance: implementWidth / 2 + 0.01, // inflate implement width by 1 cm to avoid gaps in buffer when overlap is 0
			endCapStyle: "flat",
		});
	});

	// Union all the individual swath polygons into a single geometry
	const unionedCoverage = union({
		type: "FeatureCollection",
		features: estimatedCoverageFeatures,
	});

	return unionedCoverage?.geometry;
}
